import { ark as o } from "@ark-ui/react/factory";
import { tableRecipe as e } from "@huspy/styled-system/recipes";
import { createStyleContext as r } from "../../utils/createStyleContext.mjs";
const { withProvider: c, withContext: t } = r(e), n = c(o.table, "root"), a = t(o.tbody, "body"), d = t(o.caption, "caption"), i = t(
  o.td,
  "cell"
), s = t(o.tfoot, "footer"), l = t(o.thead, "head"), p = t(o.th, "header"), h = t(o.tr, "row"), w = {
  Root: n,
  Body: a,
  Caption: d,
  Cell: i,
  Foot: s,
  Head: l,
  Header: p,
  Row: h
};
export {
  w as Table
};
